import { Link } from "react-router-dom";
import { Phone, Calendar } from "lucide-react";

const MobileCTA = () => {
  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-[9999] md:hidden"
      data-testid="mobile-sticky-cta"
    >
      {/* Main buttons */}
      <div className="flex bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
        {/* Call Button */}
        <a
          href="tel:+447547393455"
          className="flex-1 flex items-center justify-center gap-2 py-4 bg-primary text-white font-semibold hover:bg-primary/90 transition-colors"
          data-testid="mobile-call-btn"
        >
          <Phone className="w-5 h-5" />
          <span>Call Now</span>
        </a>
        
        {/* Book Quote Button */}
        <Link
          to="/book"
          className="flex-1 flex items-center justify-center gap-2 py-4 bg-gray-900 text-white font-semibold hover:bg-gray-800 transition-colors"
          data-testid="mobile-book-btn"
        >
          <Calendar className="w-5 h-5" />
          <span>Book Quote</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileCTA;
